/**
 * -----------
 * ajax heler
 * -----------
 */

const Ajax = (opts) => {
  const serialize = (obj) => {
    const pairs = []
    for (let prop in obj) {
      if (!obj.hasOwnProperty(prop)) continue

      if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
        pairs.push(serialize(obj[prop]))
        continue
      }

      pairs.push(prop + '=' + obj[prop])
    }
    return pairs.join('&')
  }

  const getHttpRequestObject = () => {
    let xhr = false

    // Mozilla/Safari/Non-IE
    if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest()
    } else if (window.ActiveXObject) { // IE
      xhr = new ActiveXObject('Microsoft.XMLHTTP')
    }
    return xhr
  }

  const doAjax = (action, method = 'GET', async = true, responseHandler, data = null) => {
    if (!action) return false

    return new Promise((resolve, reject) => {
      const xhr = getHttpRequestObject()

      if (xhr !== false) {
        xhr.open(method, action, async)
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')


        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              // responseHandler(xhr)
              resolve(JSON.parse(xhr.responseText))
            } else {
              reject(xhr.status)
            }
          }
        }

        if (method === 'POST') {
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
          xhr.send(serialize(data))
        }

        if (method === 'GET') {
          xhr.open('GET', action, true)
          xhr.send('')
        }
      }
    })
  }

  return {
    get: (action, responseFunction) => doAjax(action, 'GET', true, responseFunction, null),
    post: (action, ajaxData, responseFunction) => doAjax(action, 'POST', true, responseFunction, ajaxData),
  }
}

export default Ajax




// WEBPACK FOOTER //
// src/assets/js/front-end/common/ajax.js